import React, { useEffect } from 'react';
import { googleLogout } from '@react-oauth/google';
import { useNavigate } from 'react-router-dom';

const Logout = ({ login, setLogin, setUserID, setUserName,setAuthToken }) => {

    const navigate = useNavigate();

    useEffect(()=> {
        setLogin(false);
        setUserID('');
        setUserName('');
        setAuthToken(null);
    }, []);

    useEffect(()=>{
        if(login === false) {
            // signOut();
            localStorage.clear();
            googleLogout();
            navigate('/Login');
        }
    }, [login]);


    return (
        <></>
    );
}

export default Logout;